import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./Search.css";
import Calendar from "../UI/Calendar.js";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const Search = () => {
  const [hotels, setHotels] = useState([]);
  const [results, setResults] = useState(null);
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [peopleCount, setPeopleCount] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isParams, setIsParams] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const country = params.get("country");
    const from = params.get("from");
    const to = params.get("to");
    const people = params.get("people");

    if (country) setSelectedLocation(country);
    if (people) setPeopleCount(people);

    if (from && to) {
      const [fromMonth, fromDay, fromYear] = from.split("-");
      const [toMonth, toDay, toYear] = to.split("-");
      console.log(parseInt(fromDay));
      setSelectedDateFrom({
        day: parseInt(fromDay),
        month: parseInt(fromMonth) - 1,
      });
      setSelectedDateTo({
        day: parseInt(toDay),
        month: parseInt(toMonth) - 1,
      });
    }
    if (country && people && from && to) {
      setIsParams(true);
    }
  }, [location.search]);

  useEffect(() => {
    if (
      isParams &&
      selectedLocation &&
      selectedDateFrom &&
      selectedDateTo &&
      peopleCount
    ) {
      fetchHotels();
      setIsParams(false);
    }
  }, [selectedLocation, selectedDateFrom, selectedDateTo, peopleCount]);

  const fetchHotels = async (e) => {
    if (e) e.preventDefault();
    sessionStorage.removeItem("searchData");
    setLoading(true);
    const from = `${String(selectedDateFrom.month + 1).padStart(
      2,
      "0"
    )}-${String(selectedDateFrom.day).padStart(2, "0")}-2025`;
    const to = `${String(selectedDateTo.month + 1).padStart(2, "0")}-${String(
      selectedDateTo.day
    ).padStart(2, "0")}-2025`;
    try {
      const response = await fetch(
        `${REACT_APP_API_URL}hotels/available?from=${from}&to=${to}&country=${selectedLocation}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      const hotelsData = Array.isArray(data)
        ? data.filter((hotel) =>
            hotel.availableRooms?.some((room) => room.available > 0)
          )
        : [];
      setHotels(hotelsData);
      setResults(hotelsData);

      sessionStorage.setItem(
        "searchData",
        JSON.stringify({ hotelsData: hotelsData })
      );
      navigate(
        `/search?country=${selectedLocation}&from=${from}&to=${to}&people=${peopleCount}`
      );
    } catch (error) {
      console.error("Error fetching hotels:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const saved = sessionStorage.getItem("searchData");
    if (saved) {
      const data = JSON.parse(saved);
      if (selectedLocation && selectedDateFrom && selectedDateTo) {
        setHotels(data.hotelsData);
        setResults(data.hotelsData);
      }
    }
  }, [selectedLocation, selectedDateFrom, selectedDateTo]);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const formatDate = (date) =>
    `${date.getDate()} ${date.toLocaleString("default", { month: "short" })}`;

  const fromDate = selectedDateFrom
    ? new Date(2025, selectedDateFrom.month, selectedDateFrom.day)
    : new Date();

  const toDate = selectedDateTo
    ? new Date(2025, selectedDateTo.month, selectedDateTo.day)
    : new Date(new Date().setDate(new Date().getDate() + 10));

  useEffect(() => {
    if (!selectedDateFrom && !selectedDateTo) {
      const today = new Date();
      const defaultFromDate = today;
      const defaultToDate = new Date(today);
      defaultToDate.setDate(today.getDate() + 10);

      setSelectedDateFrom({
        day: defaultFromDate.getDate(),
        month: defaultFromDate.getMonth(),
      });

      setSelectedDateTo({
        day: defaultToDate.getDate(),
        month: defaultToDate.getMonth(),
      });
    }
  }, [selectedDateFrom, selectedDateTo]);

  const calendarHandler = (selectedRange) => {
    setSelectedDateFrom(selectedRange[0]);
    setSelectedDateTo(selectedRange.slice(-1)[0]);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${REACT_APP_API_URL}countries/all`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);
        const uniqueCountries = [
          ...new Set(data.regions.map((item) => item.countryName)),
        ];

        setCountries(uniqueCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <div className="search-container">
          <h1 className="search-header">Let's travel the world</h1>
          <p className="header-subtitle">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
          <form className="search-wrapper" onSubmit={fetchHotels}>
            <div className="search-input trip-group">
              <div className="search-element">
                <label>Location:</label>
                <div className="select">
                  <i className="fa fa-map-marker"></i>
                  <select
                    value={selectedLocation}
                    onChange={(e) => {
                      setSelectedLocation(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select location</option>
                    {countries.map((country) => (
                      <option value={country}>{country}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="search-element">
                <span>Date</span>
                <div
                  onClick={() => setCalendarOpen((current) => !current)}
                  className="calendar-form"
                >
                  <i className="fa fa-calendar"></i>
                  <div>
                    <span>From: {formatDate(fromDate)}</span>
                  </div>
                  <span> - </span>
                  <div>
                    <span>To: {formatDate(toDate)}</span>
                  </div>
                </div>
              </div>
              <div className="guests search-element">
                <label htmlFor="peopleNumber">Number of People</label>
                <div className="select">
                  <i className="fa fa-user"></i>
                  <select
                    id="peopleNumber"
                    name="peopleNumber"
                    value={peopleCount}
                    onChange={(e) => setPeopleCount(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      Select Number of People
                    </option>
                    {[1, 2, 3, 4, 5].map((num) => (
                      <option key={num} value={num}>
                        {num} {num === 1 ? "Person" : "People"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <button className="search-icon" type="submit">
              <i className="fa fa-search"></i>
            </button>
            {calendarOpen && <Calendar calendarHandler={calendarHandler} />}
          </form>
        </div>

        <section className="hero-section">
          <div className="hero-images">
            <div
              className="hero-image hero-image-one"
              style={{
                backgroundImage:
                  "url('https://res.cloudinary.com/dshalmvbb/image/upload/v1771699877/IMG-399955dd5cab7c479ee5fb5fddc25fa6-V_ajzjcc.jpg')",
              }}
            ></div>
            <div
              className="hero-image hero-image-two"
              style={{
                backgroundImage:
                  "url('https://res.cloudinary.com/dshalmvbb/image/upload/v1771766334/IMG_20260222_151415_458_pcfcjq.jpg')",
              }}
            ></div>
            <div
              className="hero-image hero-image-three"
              style={{
                backgroundImage:
                  "url('https://res.cloudinary.com/dshalmvbb/image/upload/v1771699344/IMG_20250803_194658-EFFECTS_ghfcnn.jpg')",
              }}
            ></div>
          </div>
        </section>
      </div>

      <section className="popular-destinations">
        <div className="dsa2">
          <div className="header-with-buttons">
            <h2>
              {results && results.length > 0
                ? `Found in ${results[0]?.region?.countryName}`
                : "Popular Destinations"}
            </h2>
            <div className="carousel-buttons">
              <button onClick={scrollLeft} className="arrow-button left">
                &#8249;
              </button>
              <button onClick={scrollRight} className="arrow-button right">
                &#8250;
              </button>
            </div>
          </div>
          {console.log()}

          <div className="destinations" ref={scrollRef}>
            {loading ? (
              <div className="loading-container">
                <div className="loading">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            ) : (
              <>
                {results ? (
                  <>
                    {results.map((item) => (
                      <div
                        key={item.hotelId}
                        className="destination-card"
                        onClick={(e) => {
                          if (
                            e.target.tagName.toLowerCase() !== "button" &&
                            !e.target.closest("button")
                          ) {
                            navigate(`/hotel/${item.hotelId}`);
                          }
                        }}
                      >
                        {item.images?.[0] && (
                          <div className="img-container">
                            <img src={item.images[0].url} alt="Preview" />
                          </div>
                        )}
                        <h3>{item.hotelName}</h3>
                        <div className="detail-container">
                          <p>${item.price} Starting</p>
                          <p>
                            <i className="fa fa-star"></i>
                            {item.hotelRating}
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    <div className="destination">
                      <div className="destination-image">
                        <img src="https://res.cloudinary.com/dshalmvbb/image/upload/v1771699865/IMG_20250809_085105_tkocew.jpg" />
                      </div>

                      <p>Lindos, Greece</p>
                    </div>
                    <div className="destination">
                      <div className="destination-image">
                        <img src="https://res.cloudinary.com/dshalmvbb/image/upload/v1771703244/IMG-b0981aa6b7e330eaac5c2bf1209158e2-V_miyofd.jpg" />
                      </div>

                      <p>Ghent, Belgium</p>
                    </div>
                    <div className="destination">
                      <div className="destination-image">
                        <img src="https://res.cloudinary.com/dshalmvbb/image/upload/v1771700520/IMG_20190810_100250_ptnhc8.jpg" />
                      </div>

                      <p>Katun Reževići, Montenegro</p>
                    </div>
                    <div className="destination">
                      <div className="destination-image">
                        <img src="https://res.cloudinary.com/dshalmvbb/image/upload/v1771699342/IMG-ca60f625c883f82d1a798403408d4b4d-V_qm1wvb.jpg" />
                      </div>

                      <p>Paris, France</p>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Search;
